var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attempts-indicator"},[_vm._l((_vm.total),function(n){return [(n <= _vm.total - _vm.used)?_c('heart-full',{key:n,staticClass:"attempt-icon"}):_c('heart-empty',{key:n,staticClass:"attempt-icon"})]})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }